import { createTheme } from '@mui/material/styles';

// MUI defaults matched to theme/exchange.css so dialogs, popovers, tables,
// inputs and menus look like the rest of the exchange.
const C = {
  bg: '#0b1418',
  panel: '#0f1a1f',
  panel2: '#14232a',
  line: '#1f2d33',
  line2: '#2a3d45',
  text: '#f6fefd',
  muted: '#949e9c',
  up: '#50d2c1',
  down: '#ed7088'
};
const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

const muiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: C.up, contrastText: '#04201c' },
    secondary: { main: '#7aa7ff' },
    success: { main: C.up },
    error: { main: C.down },
    warning: { main: '#f4a932' },
    background: { default: C.bg, paper: C.panel },
    text: { primary: C.text, secondary: C.muted },
    divider: C.line
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: FONT,
    button: { textTransform: 'none', fontWeight: 600 }
  },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiDialog: {
      styleOverrides: {
        paper: { background: C.panel, border: `1px solid ${C.line}`, borderRadius: 12 }
      }
    },
    MuiPopover: { styleOverrides: { paper: { background: C.panel, border: `1px solid ${C.line2}` } } },
    MuiMenu: { styleOverrides: { paper: { background: C.panel, border: `1px solid ${C.line2}` } } },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: C.line, fontVariantNumeric: 'tabular-nums' },
        head: { color: C.muted, fontWeight: 500, fontSize: 12 }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { background: '#1a2c34', border: `1px solid ${C.line2}`, fontSize: 12, fontFamily: FONT },
        arrow: { color: '#1a2c34' }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { background: C.panel2, '& fieldset': { borderColor: C.line } }
      }
    },
    MuiButton: { styleOverrides: { root: { borderRadius: 8, boxShadow: 'none' } } },
    MuiBackdrop: { styleOverrides: { root: { backgroundColor: 'rgba(3, 8, 10, 0.72)' } } }
  }
});

export default muiTheme;
